import { render, staticRenderFns } from "./dashboardPSMBGE.vue?vue&type=template&id=26654534&scoped=true&"
import script from "./dashboardPSMBGE.vue?vue&type=script&lang=js&"
export * from "./dashboardPSMBGE.vue?vue&type=script&lang=js&"
import style0 from "./dashboardPSMBGE.vue?vue&type=style&index=0&id=26654534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26654534",
  null
  
)

export default component.exports